import React from 'react';

const ReservationLoader = () => {
  const loadingStyle = {
    background: 'linear-gradient(90deg, #e8e8e8 25%, #f5f5f5 50%, #e8e8e8 75%)',
    backgroundSize: '200% 100%',
    animation: 'loading 1.5s infinite',
    borderRadius: '25px',
  };

  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes loading {
        0% { background-position: 200% 0; }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  return (
    <div style={{
      padding: 0,
      margin: 0,
      minHeight: 'auto',
    }}>
      <div style={{ position: 'relative', marginBottom: 0 }}>
        <div
          style={{
            ...loadingStyle,
            width: '100%',
            height: '42px',
          }}
        />
        <span
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '42px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '12px',
            color: 'rgba(0,0,0,0.35)',
            fontWeight: 400,
            letterSpacing: '0.2px',
            pointerEvents: 'none'
          }}
        >
          Loading available dates...
        </span>
      </div>
    </div>
  );
};

export default ReservationLoader;